import {
  ItemStatsModel,
  type ItemStatsQueryModel,
  itemClient,
} from '@merchant-clients/item';

import { useClientQuery } from '@frontend/hooks';

export interface UseItemStatsQueryProps {
  shopId: string;
  placeIds: string[] | undefined;
  /**
   * The resolved range, not the preset name: it is part of the query key, so a
   * persisted "today" from an earlier day is never shown as the current one.
   */
  period: Pick<ItemStatsQueryModel, 'from' | 'to'>;
  onError?(error: Error): void;
}

export const getItemStatsQueryKey = (
  shopId: string,
  filterSignature: string,
) => ['item-stats', shopId, filterSignature];

export const useItemStatsQuery = ({
  shopId,
  placeIds,
  period: { from, to },
  onError,
}: UseItemStatsQueryProps) => {
  const filterSignature = JSON.stringify({ placeIds, from, to });

  return useClientQuery<ItemStatsModel[]>({
    queryKey: getItemStatsQueryKey(shopId, filterSignature),
    enabled: !!shopId,
    async onFetch() {
      return await itemClient.stats(shopId, {
        from,
        to,
        placeIds,
      });
    },
    onError,
  });
};
